<template>
    <FormSelect v-bind="$attrs" :label="label" @input="$emit('input', $event)">
        <option v-for="timeZone in timeZones" :key="timeZone.value" :value="timeZone.value">{{ timeZone.title }}</option>
    </FormSelect>
</template>


<script>
export default {
    name: 'FormSelectTimeZone',
    inheritAttrs: false,

    props: {
        label: { type: String, default: 'Time Zone' },
    },

    data: () => ({
        timeZones: [
            { value: 'America/Phoenix', title: 'Phoenix' },
            { value: 'America/New_York', title: 'New York (Eastern)' },
            { value: 'America/Chicago', title: 'Chicago (Central)' },
            { value: 'America/Denver', title: 'Denver (Mountain)' },
            { value: 'America/Los_Angeles', title: 'Los Angeles (Pacific)' },
        ],
    }),
};
</script>
